import instance from '../utils/axios';

export const getOpenBetByEvent = async (eventId) => {
    const response = await instance.get(`/api/betting/get-all-open-bet-by-event/${eventId}`);
    return response.data;
};

export const deleteOpenBetByEvent = async (bettingId) => {
    const response = await instance.delete(`/api/betting/delete-bet-by-betting-id/${bettingId}`);
    return response.data;
};


export const getChips = async () => {
    const response = await instance.get('/api/chips/getChips');
    return response.data;
};

export const updateChip = async (chipId) => {
    const response = await instance.put(`/api/chips/${chipId}`);
    return response.data;
};

export const updateChipList = async (chipData) => {
    const response = await instance.post(`/api/chips/updateMultipleChips`, chipData);
    return response.data;
};

export const deleteChip = async (chipId) => {
    const response = await instance.delete(`/api/chips/${chipId}`);
    return response.data;
};

export const createChip = async (chipData) => {
    const response = await instance.post('/api/chips/addChip', chipData);
    return response.data;
};